/* @flow weak */
import User from './user';
import {Record} from '../transit';
import * as actions from './actions';
import * as loginActions from '../login/actions';
import * as categoriesActions from '../categories/actions';
import http from '../lib/http';
import jwtDecode from 'jwt-decode';
import * as appAction from '../app/actions';
import constants from '../constants'
import {List, fromJS} from 'immutable';

const State = Record({
    viewer: null,
    token: null,
    lastAction: 0,
    allowLoginByPin: false,
    sellers: List(),
    locked: false,
    pinAttempt: 5,
    showButtonLock: false
}, 'users');

const SHOW_BUTTON_LOCK = 'showButtonLock';
const LOCKED = 'locked';
const VIEWER = 'viewer';
const PIN_ATTEMPT = 'pinAttempt';
const SELLERS = 'sellers';
const TOKEN = 'token';
const LAST_ACTION = 'lastAction';
const ALLOW_LOGIN_BY_PIN = 'allowLoginByPin';

const usersReducer = (state = new State(), action) => {
    switch (action.type) {

        case categoriesActions.FETCH_INIT_APP_SUCCESS: {
            const {sellers} = action.payload.data;
            const sellersList = fromJS(sellers);
            return state
                .set(SHOW_BUTTON_LOCK, sellersList.size > 0)
                .set(SELLERS, sellersList);
        }

        case actions.UNLOCK_USER: {
            const {pin} = action.payload;
            const seller = state.get(SELLERS).find(s => s.get('pin') === pin);
            if (!!seller) {
                return state
                    .set(VIEWER, changeViewer(seller.get('token'), seller.get('id')))
                    .set(LAST_ACTION, Date.now())
                    .set(LOCKED, false)
                    .set(TOKEN, seller.get('id'));
            }
            return state.set(PIN_ATTEMPT, state.get(PIN_ATTEMPT) - 1);
        }

        case actions.LOCK_USER: {
            return state
                .set(PIN_ATTEMPT, constants.PIN_ATTEMPT)
                .set(LOCKED, true)
        }

        case loginActions.SHOW_LOGIN_BY_PASSWORD: {
            return state
                .set(ALLOW_LOGIN_BY_PIN, false)
                .set(LAST_ACTION, 0);
        }

        case appAction.APP_STORAGE_LOAD: {
            let lastAction = state.get('lastAction');
            if (!lastAction) {
                return state.set(ALLOW_LOGIN_BY_PIN, false);
            } else if (Date.now() - (constants.TIME_TO_LOGIN_PIN * 1000) > lastAction) {
                return state.set(ALLOW_LOGIN_BY_PIN, true);
            }
            return state.set(ALLOW_LOGIN_BY_PIN, true);
        }

        case loginActions.API_LOGIN_PIN_SUCCESS:
        case loginActions.API_LOGIN_SUCCESS: {
            const {token} = action.payload.data;
            const viewer = saveViewer(token);
            return state
                .set(VIEWER, viewer)
                .set(LAST_ACTION, Date.now())
                .set(TOKEN, token);
        }

        case loginActions.API_LOGOUT: {
            return state
                .set(LAST_ACTION, Date.now())
                .set(ALLOW_LOGIN_BY_PIN, true)
                .set(VIEWER, null)
                .set(SELLERS, List())
                .set(LOCKED, false)
                .set(TOKEN, null);
        }

        default:
            return state;

    }
};

function changeViewer(token, id) {
    http.setAuthorization(token);
    return new User(initSeller(token, id));
}

function saveViewer(token) {
    http.setAuthorization(token);
    return new User(parseUserFromToken(token));
}

function initSeller(token, id) {
    return {
        token: token,
        userId: id
    };
}

function parseUserFromToken(token) {
    if (token === null) return token;
    const user = jwtDecode(token);

    return {
        token: token,
        userId: user.userId
    };
}

export default usersReducer;



// WEBPACK FOOTER //
// ./src/common/users/reducer.js